module.exports = __webpack_public_path__ + "img/car300.3e06b2d9.png";